import React from "react";
import { Link } from "react-router-dom";
import { AllPrograms } from "../interfaces/Program";

interface ProgramMinimalCardProps {
  program: AllPrograms;
  className?: string;
}

export default function ProgramMinimalCard({
  program,
  className = "",
}: ProgramMinimalCardProps) {
  return (
    <div className={`p-4 ${className}`}>
      <Link
        to={`/program/${program.slug}`}
        className="group flex flex-col h-full overflow-hidden rounded-md transition-all duration-300 hover:shadow-2xl"
      >
        <div className="w-full h-48 md:h-72 xl:h-[22rem] overflow-hidden bg-black/20 shrink-0">
          <img
            src={program.icon}
            alt={program.title || "Program image"}
            className="w-full h-full object-cover rounded-tl-md rounded-tr-md group-hover:scale-105 transition-transform duration-500 ease-out"
          />
        </div>
        <div className="p-4 md:p-4 lg:p-8 shadow-lg rounded-bl-md rounded-br-md mb-6 bg-[#504032] group-hover:bg-[#5c4a3b] transition-colors duration-300 flex-1 flex flex-col justify-between">
          <div className="flex flex-col items-start gap-4">
            <h3
              className="text-lg md:text-2xl text-white font-semibold pr-2 line-clamp-2 min-h-[3.5rem] md:min-h-[4rem] w-full"
              title={program.title}
            >
              {program.title}
            </h3>
            <svg
              width="20"
              height="14"
              viewBox="0 0 24 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transform group-hover:translate-x-1.5 transition-transform duration-300 shrink-0"
            >
              <path
                d="M21 7.5H2"
                stroke="white"
                strokeWidth="2.1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.1914 2L22.715 7.49906L17.1914 13"
                stroke="white"
                strokeWidth="2.1"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </Link>
    </div>
  );
}
